import { type RouterInput, useTrpc } from '#composables/useTrpc';

type GetHasStoresClosedForLessThanAMonthInput =
  RouterInput['performance']['likeForLike']['hasStoresClosedForLessThanAMonth'];
export async function getHasStoresClosedForLessThanAMonth(query: GetHasStoresClosedForLessThanAMonthInput) {
  return useTrpc().performance.likeForLike.hasStoresClosedForLessThanAMonth.mutate(query);
}

type GetLikeForLikePerimeterInput = RouterInput['performance']['likeForLike']['getLikeForLikePerimeter'];
export async function getLikeForLikePerimeter(query: GetLikeForLikePerimeterInput, signal?: AbortSignal) {
  return useTrpc().performance.likeForLike.getLikeForLikePerimeter.mutate(query, { signal });
}
